import { Helmet } from 'react-helmet-async';
import { Seo } from '@/components/site/seo';
import { FaqsSection } from '@/components/site/sections/faqs';
import { BannerHero } from '@/components/site/banner-hero';
import { listFaqs } from '@/lib/data/public';
import { localeField } from '@/lib/i18n/helpers';
import { useLiveData } from '~/hooks/useLiveData';
import { useLocaleContext } from '~/hooks/useLocaleContext';

export default function FaqsPage() {
  const { locale, dict } = useLocaleContext();
  const faqs = useLiveData(listFaqs, [locale]).data ?? [];

  const faqLd = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqs.map((f) => ({
      '@type': 'Question',
      name: localeField(f, 'question', locale),
      acceptedAnswer: { '@type': 'Answer', text: localeField(f, 'answer', locale) },
    })),
  };

  return (
    <>
      <Seo
        locale={locale}
        title={dict.faqs.title}
        description={dict.faqs.subtitle}
        path="/preguntas"
        image="/banners/banner-web-7.jpg"
      />
      {faqs.length > 0 && (
        <Helmet>
          <script type="application/ld+json">{JSON.stringify(faqLd)}</script>
        </Helmet>
      )}
      <BannerHero image="/banners/banner-web-7.jpg" title={dict.faqs.title} />
      <FaqsSection locale={locale} dict={dict} faqs={faqs} compact />
    </>
  );
}
